var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"d-flex align-items-center justify-center",attrs:{"fill-height":""}},[_c('v-progress-circular',{attrs:{"size":"72","indeterminate":"","color":"primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }